import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import { translate } from "utils";
import {
	getListSubscriptionPackageAsync,
	GetListSubscriptionPackageAsyncPayload,
	setListSubscriptionPackage,
} from "./subscription-package.slice";
import { listSubscriptionPackagesAPI } from "service/apis/subscription-package";

// Get list
function* getListSubscriptionPackageSaga(
	action: PayloadAction<GetListSubscriptionPackageAsyncPayload>,
) {
	const { data, error } = yield call(async () => {
		const { query, callback } = action.payload;

		try {
			const data = await listSubscriptionPackagesAPI(query);
			if (data) {
				callback?.();
			}
			return { data };
		} catch (error) {
			return { error };
		}
	});
	if (data) {
		yield put({ type: setListSubscriptionPackage.type, payload: data });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListSubscriptionPackage() {
	yield takeLatest(
		getListSubscriptionPackageAsync,
		getListSubscriptionPackageSaga,
	);
}

const subscriptionPackageSaga = [watchGetListSubscriptionPackage()];
export default subscriptionPackageSaga;
